import { openCaptcha } from '@/utils/captcha'
import { withResolvers } from '@/utils/promise'
import { jstLogEvent } from '@/utils/logger'

const requestCacheManager = {
    cacheList: new Set(),
    isVerifying: false,
    setVerifying(value) {
        this.isVerifying = value
    },
    add(requestConfig) {
        this.cacheList.add(requestConfig)
    },
    remove(requestConfig) {
        this.cacheList.delete(requestConfig)
    }
}

// 验证码处理函数
export default ({ request, options, data }) => {
    const resolvers = withResolvers()

    const requestConfig = {
        request,
        url: options.url,
        options: {
            ...options,
            prefix: '',
            retryCount: (options.retryCount || 0) + 1
        },
        data,
        resolvers
    }

    requestCacheManager.add(requestConfig)

    if (!requestCacheManager.isVerifying) {
        requestCacheManager.setVerifying(true)

        let isAutoClose = false

        const retryRequest = () => {
            requestCacheManager.setVerifying(false)

            requestCacheManager.cacheList.forEach(v => {
                const retry = v.request(v.url, v.options)

                v.resolvers.resolve(retry)

                requestCacheManager.cacheList.delete(v)
            })
        }

        const finishRequest = () => {
            requestCacheManager.setVerifying(false)

            requestCacheManager.cacheList.forEach(v => {
                v.resolvers.resolve(v.data)

                requestCacheManager.cacheList.delete(v)
            })
        }

        const urlObj = new URL(options.url)

        import('@/utils/request')
            .then(res => {
                openCaptcha({
                    getEncryptedSceneId() {
                        return res?.securityRequest.post('/captcha/getEncryptedSceneId').then(res => res?.data)
                    },
                    success(e) {
                        console.info('openCaptcha success:', e)

                        isAutoClose = true

                        res?.securityRequest
                            .post('/captcha/validate', {
                                data: {
                                    captchaVerifyParam: e,
                                    url: urlObj.pathname
                                }
                            })
                            .then(res => {
                                retryRequest()

                                if (!res?.data) {
                                    jstLogEvent({
                                        element: 'captchaVerification',
                                        args: {
                                            message: res?.message || '校验未通过',
                                            url: urlObj.pathname,
                                            callback: 'success'
                                        }
                                    })
                                }
                            })
                            .catch(e => {
                                console.info('openCaptcha success:', e)

                                retryRequest()

                                jstLogEvent({
                                    element: 'captchaVerification',
                                    args: {
                                        message: e?.message || e?.error?.message || '校验异常',
                                        url: urlObj.pathname,
                                        callback: 'success'
                                    }
                                })
                            })
                    },
                    fail(e) {
                        // 报错后会自动重置滑块
                        console.info('openCaptcha fail:', e)

                        isAutoClose = true

                        jstLogEvent({
                            element: 'captchaVerification',
                            args: {
                                certifyId: e?.certifyId,
                                verifyCode: e?.verifyCode,
                                message: '验证失败',
                                url: urlObj.pathname,
                                callback: 'fail'
                            }
                        })
                    },
                    onError(e) {
                        console.info('openCaptcha onError:', e)

                        isAutoClose = true

                        jstLogEvent({
                            element: 'captchaVerification',
                            args: {
                                code: e?.code,
                                message: e?.msg || '验证码初始化接口请求和验证码资源加载失败、超时',
                                url: urlObj.pathname,
                                callback: 'onError'
                            }
                        })
                    },
                    onClose(e) {
                        if (!isAutoClose) {
                            console.info('openCaptcha onClose:', e)

                            retryRequest()

                            jstLogEvent({
                                element: 'captchaVerification',
                                args: { message: '主动关闭', url: urlObj.pathname, callback: 'onClose' }
                            })
                        }
                    }
                }).catch(e => {
                    console.info('openCaptcha catch')

                    finishRequest()

                    jstLogEvent({
                        element: 'captchaVerification',
                        args: { message: e?.message || '打开验证异常', url: urlObj.pathname, callback: 'catch' }
                    })
                })
            })
            .catch(e => {
                console.info('openCaptcha catch')

                finishRequest()

                jstLogEvent({
                    element: 'captchaVerification',
                    args: { message: e?.message || '导入request异常', url: urlObj.pathname, callback: 'catch' }
                })
            })
    }

    return resolvers.promise
}
